/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  $(".featured--product__info .accordion > .accordion-item.is-active").children(".accordion-panel").slideDown("fast");
  $(".featured--product__info .accordion > .accordion-item").click(function() {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp("fast");
    $(this).children(".accordion-thumb").toggleClass("is-active-thumb");
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("fast");
  });


   $(".faqs .accordion > .accordion-item.is-active")
    .children(".accordion-panel")
    .slideDown("fast");
  $(".faqs .accordion .accordion-thumb").click(function () {
    $(this)
      .toggleClass("is-active-thumb")
      .closest(".accordion-item")
      .toggleClass("is-active")
      .find(".accordion-panel")
      .slideToggle("fast");
    $(this).find(".icon").toggleClass("rotate--icons");
  });

$('.newsettler-button').click(function (){
    $('.newsletter-form__button').click();
});


$('.eam-slideshow').slick({
   arrows: false,
   infinite: true,
   autoplay: true,
   autoplaySpeed: 2000
});


if(window.outerWidth < 786){
  $('.custom-icons-content').slick({
                arrows: true,
                autoplay: true,
                prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.634662 7.35397C0.302716 7.02202 0.302716 6.48383 0.634662 6.15189L6.04403 0.742522C6.37597 0.410576 6.91416 0.410576 7.24611 0.742522C7.57806 1.07447 7.57806 1.61266 7.24611 1.9446L2.43778 6.75293L7.24611 11.5613C7.57806 11.8932 7.57806 12.4314 7.24611 12.7633C6.91416 13.0953 6.37597 13.0953 6.04403 12.7633L0.634662 7.35397ZM23.2357 7.60293H1.2357V5.90293H23.2357V7.60293Z" fill="black"/> </svg></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23.3653 7.35397C23.6973 7.02202 23.6973 6.48383 23.3653 6.15189L17.956 0.742522C17.624 0.410576 17.0858 0.410576 16.7539 0.742522C16.4219 1.07447 16.4219 1.61266 16.7539 1.9446L21.5622 6.75293L16.7539 11.5613C16.4219 11.8932 16.4219 12.4314 16.7539 12.7633C17.0858 13.0953 17.624 13.0953 17.956 12.7633L23.3653 7.35397ZM0.764297 7.60293H22.7643V5.90293H0.764297V7.60293Z" fill="black"/> </svg></button>'
  });
}





$('#s-09cb4bdf-b09a-4d49-90ca-924e67d22609 .shg-btn').click(function () {
        $('.pageModalBody').addClass('activeModal')
       });
       $('#s-e119f9ce-b1a9-4848-9adf-97d6f26d4c12 .shg-btn').click(function () {
        $('.pageModalBody').addClass('activeModal')
       });

$('.bgModalLayer').click(function () {
      $('.pageModalBody').removeClass('activeModal');
 });
$('.pageModalBody button').click(function () {
      $('.pageModalBody').removeClass('activeModal');
 });




document.addEventListener("DOMContentLoaded", function () {
    const minusButton = document.querySelector(".minus");
    const plusButton = document.querySelector(".plus");
    const quantityInput = document.querySelector(".qty");

    minusButton.addEventListener("click", function () {
        let currentValue = parseInt(quantityInput.value);
        if (currentValue > parseInt(quantityInput.min)) {
            quantityInput.value = currentValue - parseInt(quantityInput.step);
        }
    });

    plusButton.addEventListener("click", function () {
        let currentValue = parseInt(quantityInput.value);
        if (quantityInput.max === "" || currentValue < parseInt(quantityInput.max)) {
            quantityInput.value = currentValue + parseInt(quantityInput.step);
        }
    });
});






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
